<template lang="pug">
  div
    Loader
    Search.search(@selected="navigate")
</template>

<script>
  import Search from '@/components/Search.vue'
  import Loader from '@/components/Loader.vue'

  export default {
    name: 'Home',
    components: {
      Search,
      Loader
    },
    methods: {
      navigate(loc) {
        this.$store.commit('setSelectedProduct', null)
        this.$router.push({
          name: 'location',
          params: { address: loc.description }
        })
      }
    }
  }
</script>

<style scoped>
  .search {
    margin: 0 2rem;
  }
</style>
